import React from "react";
import { Link } from "react-router-dom";

import "../assets/css/Adminnav.scss";

const Adminnav = ({ adminNav, adminUsers, adminProducts, adminOrders }) => {
  return (
    <div className="nav_container">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <Link className={`nav-link ${adminNav}`} to="/admin">
            Admin
          </Link>
        </li>
        <li className="nav-item">
          <Link className={`nav-link ${adminUsers}`} to="/admin/users">
            Users
          </Link>
        </li>
        <li className="nav-item">
          <Link className={`nav-link ${adminProducts}`} to="/admin/products">
            Products
          </Link>
        </li>
        <li className="nav-item">
          <Link className={`nav-link ${adminOrders}`} to="/admin/orders">
            Orders
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Adminnav;
